<div
  style="
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 5px;
    margin-top: 8px;
    margin-left: 10px;
    margin-right: 10px;
  "
>
  <section id="cdi-customer-portal-section" *ngIf="!showInvoiceSection">
    <h1 style="font-size: 2rem">Customer Portal</h1>
    <img
      src="img/billboard-CascadeDesigns-ElasticMarquee-1.jpg"
      alt="Welcome"
      style="max-width: 100%; width: 100%; height: 400px"
    />
    <div
      id="cdi-sub-banner"
      style="display: flex; justify-content: center; align-items: center"
    >
      <h2>Decades of Adventurous Innovation</h2>
    </div>
    <div id="cdi-sub-banner-text1" style="text-align: center; width: 100%">
      <p>
        <span class="cdi-sentence">
          Cascade Designs, Inc. began over 50 years ago with the simple idea of
          providing a more comfortable night outdoors. Since then, we have grown
          to become the parent company of some of the most respected brands in
          the outdoor industry.
        </span>
      </p>
      <p>
        <span class="cdi-sentence">
          Though much has changed with this success, our recipe for achieving it
          has not. We believe that manufacturing as much of our gear in our U.S.
          and European facilities as possible is essential in maintaining
          quality. By striving to exceed our customers performance and service
          expectations, we will be successful for years to come.</span
        >
      </p>
    </div>
  </section>
  <section id="cdi-sales-order-section" *ngIf="showInvoiceSection">
    <section id="cdi-invoice">
      <div
        style="display: flex; justify-content: space-between; align-items: top"
      >
        <span id="span-company-info">
          Cascade Designs Nevada, LLC<br />
          11500 Production Drive<br />
          Reno, NV 89506<br />
          Phone: <a href="tel:8008274548">800-827-4548</a><br />
          Phone: <a href="tel:206-505-9500">206-505-9500</a><br />
        </span>
        <span id="span-general-order-info">
          Order Date:&nbsp;{{
            order?.poHeaderInfo?.orderDate | date: "MMMM dd, yyyy"
          }}<br />
          JDE Order Number:&nbsp;{{ order?.poHeaderInfo?.orderNumber }}<br />
        </span>
      </div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: top;
          margin-top: 10px;
          margin-left: 25px;
          margin-right: 25px;
        "
      >
        <span id="span-bill-to">
          <h2>Bill To</h2>
          {{ order?.dealerBillToAddress?.companyName }}<br />
          {{ order?.dealerBillToAddress?.streetAddress1 }}<br />
          <span *ngIf="order?.dealerBillToAddress?.streetAddress2"
            >{{ order?.dealerBillToAddress?.streetAddress2 }}<br
          /></span>
          <span *ngIf="order?.dealerBillToAddress?.streetAddress3"
            >{{ order?.dealerBillToAddress?.streetAddress3 }}<br
          /></span>
          <span *ngIf="order?.dealerBillToAddress?.streetAddress4"
            >{{ order?.dealerBillToAddress?.streetAddress4 }}<br
          /></span>
          {{ order?.dealerBillToAddress?.city }}&nbsp;{{
            order?.dealerBillToAddress?.state
          }}&nbsp;{{ order?.dealerBillToAddress?.zipCode }}<br />
          {{ order?.dealerBillToAddress?.countryCode }}<br />
        </span>
        <span id="span-ship-to">
          <h2>Ship To</h2>
          {{ order?.dealerShipToAddress?.companyName }}<br />
          {{ order?.dealerShipToAddress?.streetAddress1 }}<br />
          <span *ngIf="order?.dealerShipToAddress?.streetAddress2"
            >{{ order?.dealerShipToAddress?.streetAddress2 }}<br
          /></span>
          <span *ngIf="order?.dealerShipToAddress?.streetAddress3"
            >{{ order?.dealerShipToAddress?.streetAddress3 }}<br
          /></span>
          <span *ngIf="order?.dealerShipToAddress?.streetAddress4"
            >{{ order?.dealerShipToAddress?.streetAddress4 }}<br
          /></span>
          {{ order?.dealerShipToAddress?.city }}&nbsp;{{
            order?.dealerShipToAddress?.state
          }}&nbsp;{{ order?.dealerShipToAddress?.zipCode }}<br />
          {{ order?.dealerShipToAddress?.countryCode }}<br />
        </span>
      </div>
      <div
        style="
          display: flex;
          justify-content: flex-start;
          align-items: top;
          margin-top: 10px;
          margin-left: 25px;
          margin-right: 25px;
        "
      >
        <span id="span-po-header"> </span>
        <h2>PO Header Info</h2>
      </div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: top;
          margin-top: 5px;
          margin-left: 25px;
          margin-right: 25px;
        "
      >
        <span id="span-1">
          Customer Number:&nbsp;{{ order?.dealerBillToAddress?.accountNumber }}
          <br />
          Customer PO:&nbsp;{{ order?.poHeaderInfo?.poNumber }}<br />
          Payment Terms:&nbsp;{{ order?.poHeaderInfo?.paymentTermDescription
          }}<br />
        </span>
        <span id="span-2">
          Mode of Transportation:&nbsp;{{
            order?.poHeaderInfo?.modeOfTransportationCodeDescription
          }}<br />
          Freight Terms:&nbsp;{{ order?.poHeaderInfo?.freightCodeDescription
          }}<br />
          Carrier:&nbsp;{{ order?.poHeaderInfo?.carrierName }}<br />
        </span>
      </div>
      <div
        style="
          display: flex;
          justify-content: flex-start;
          align-items: top;
          margin-top: 10px;
          margin-left: 25px;
          margin-right: 25px;
        "
      >
        <span id="span-order-details"> </span>
        <h2>Order Details</h2>
      </div>
      <div
        style="
          display: flex;
          justify-content: flex-start;
          align-items: top;
          margin-top: 5px;
          margin-left: 25px;
          margin-right: 25px;
        "
      >
        <table id="table-order-detail">
          <thead>
            <tr>
              <th>Line No</th>
              <th>Item No</th>
              <th>Description</th>
              <th>Status</th>
              <th>Qty</th>
              <th>Unit Price</th>
              <th>Extended Price</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of order?.orderDetails">
              <td>{{ row.lineNumber }}</td>
              <td>{{ row.itemNumber }}</td>
              <td>{{ row.itemDescription }}</td>
              <td>{{ row.orderStatus }}</td>
              <td>{{ row.orderedQty }}</td>
              <td>
                {{ row.unitPrice | number: "1.2-2" }}&nbsp;{{
                  row.currencyCode
                }}
              </td>
              <td>
                {{ row.lineTotal | number: "1.2-2" }}&nbsp;{{
                  row.currencyCode
                }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Subtotal</td>
              <td id="cdi-order-subtotal">
                {{ order?.orderAmount | number: "1.2-2" }}&nbsp;{{
                  order?.currencyCode
                }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td id="cdi-order-tax-rate">
                Tax&nbsp;{{ order?.taxRate | percent: "1.0-2" }}
              </td>
              <td id="cdi-order-tax-amount">
                {{
                  ((order?.orderTotal ?? 0) - (order?.orderAmount ?? 0))
                    | number: "1.2-2"
                }}&nbsp;{{ order?.currencyCode }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="background-color: #fdfbd4">Amount Due</td>
              <td id="cdi-order-amount-due" style="background-color: #fdfbd4">
                {{ order?.orderTotal | number: "1.2-2" }}&nbsp;{{
                  order?.currencyCode
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="height: 50px"></div>
      <div
        style="
          display: flex;
          justify-content: flex-end;
          margin-left: 10px;
          margin-right: 10px;
          margin-bottom: 10px;
        "
      >
        <p-button
          *ngIf="this.showMakePaymentButton"
          id="cdi-btn-make-payment"
          label="Make Payment"
          severity="success"
          size="large"
          (click)="showPaymentDialog()"
        ></p-button>
        <span id="cdi-banner-paid" *ngIf="!this.showMakePaymentButton">
          <svg
            width="96"
            height="32"
            viewBox="0 0 96 32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="16"
              cy="16"
              r="12"
              fill="none"
              stroke="#00693E"
              stroke-width="2"
            />
            <path
              d="M11 16l3 3 7-7"
              fill="none"
              stroke="#00693E"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <text
              x="34"
              y="21"
              font-family="Arial, sans-serif"
              font-size="24"
              font-weight="700"
              fill="#00693E"
            >
              PAID
            </text>
          </svg></span
        >
      </div>
      <div style="height: 50px"></div>
    </section>

    <section id="cdi-payment-confirmation">
      <p-dialog
        id="cdi-payment-confirmation-dialog"
        header="PAYMENT CONFIRMATION"
        [modal]="true"
        [(visible)]="displayPaymentConfirmationDialog"
        [style]="{ width: '30rem' }"
        (onHide)="onPaymentConfirmationDialogHide()"
        [resizable]="false"
      >
        <div>
          <span class="cdi-form-field">
            <p>Date</p>
            <p id="cdi-payment-confirmation-dialog-date">
              {{ paymentResponse?.date | date: "MMMM dd, yyyy HH:mm:ss" }}
            </p>
          </span>
          <span class="cdi-form-field">
            <p>Transaction Id</p>
            <p>{{ paymentResponse?.transactionId }}</p>
          </span>
          <span class="cdi-form-field">
            <p>Reconciliation Id</p>
            <p id="cdi-payment-confirmation-dialog-reconciliationId">
              {{ paymentResponse?.reconciliationId }}
            </p>
          </span>
          <span class="cdi-form-field">
            <p>Authorization Code</p>
            <p id="cdi-payment-confirmation-dialog-authorizationCode">
              {{ paymentResponse?.authorizationCode }}
            </p>
          </span>
          <span class="cdi-form-field">
            <p>Status</p>
            <p id="cdi-payment-confirmation-dialog-status">
              {{ paymentResponse?.status }}
            </p>
          </span>
        </div>
      </p-dialog>
    </section>
    <section id="cdi-payment-dialog-section">
      <p-dialog
        id="cdi-payment-dialog"
        header="PAYMENT"
        [modal]="true"
        [(visible)]="displayPaymentDialog"
        [style]="{ width: '35rem' }"
        (onHide)="onPaymentDialogHide()"
      >
        <form
          id="cdi-form-payment"
          [formGroup]="paymentForm"
          (ngSubmit)="submitPayment()"
          autocomplete="on"
          novalidate
        >
          <section id="cdi-paymentdialog-billinginformation-section">
            <span><h2>Billing Information</h2></span>
            <span class="cdi-form-field cdi-form-row">
              <label for="cc-given-name">First Name</label>
              <input
                pInputText
                id="cc-given-name"
                type="text"
                formControlName="firstName"
                name="cc-given-name"
                autocomplete="cc-given-name"
                inputmode="text"
                maxlength="60"
              />
            </span>
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('firstName')?.touched &&
                paymentForm.get('firstName')?.invalid
              "
              >Enter a first name (max 60 characters).</small
            >
            <span class="cdi-form-field cdi-form-row">
              <label for="cc-family-name">Last Name</label>
              <input
                pInputText
                id="cc-family-name"
                type="text"
                formControlName="lastName"
                name="cc-family-name"
                autocomplete="cc-family-name"
                inputmode="text"
                maxlength="60"
              />
            </span>
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('lastName')?.touched &&
                paymentForm.get('lastName')?.invalid
              "
              >Enter a last name (max 60 characters).</small
            >
            <span class="cdi-form-field cdi-form-row">
              <label for="billing-line1">Street Address 1</label>
              <input
                pInputText
                id="billing-line1"
                type="text"
                formControlName="streetAddress1"
                name="billing street-address"
                autocomplete="billing street-address"
                inputmode="text"
                maxlength="60"
              />
            </span>
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('streetAddress1')?.touched &&
                paymentForm.get('streetAddress1')?.invalid
              "
              >Street address is required.</small
            >
            <span class="cdi-form-field cdi-form-row">
              <label for="billing-line2">Street Address 2</label>
              <input
                pInputText
                id="billing-line2"
                type="text"
                formControlName="streetAddress2"
                name="billing address-line2"
                autocomplete="billing address-line2"
                inputmode="text"
                maxlength="60"
              />
            </span>
            <span class="cdi-form-field cdi-form-row">
              <label for="billing-city">City</label>
              <input
                pInputText
                id="billing-city"
                type="text"
                formControlName="city"
                name="billing address-level2"
                autocomplete="billing address-level2"
                inputmode="text"
                maxlength="60"
              />
            </span>
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('city')?.touched &&
                paymentForm.get('city')?.invalid
              "
              >City is required.</small
            >
            <span class="cdi-form-field cdi-form-row">
              <label for="billing-state">{{
                usesSubdivisionDropdown()
                  ? 'State / Province'
                  : 'State / Province / Region'
              }}</label>
              <p-autoComplete
                *ngIf="usesSubdivisionDropdown()"
                inputId="billing-state"
                formControlName="state"
                [suggestions]="filteredStates"
                (completeMethod)="filterStates($event)"
                (onSelect)="onStateSelect($event)"
                optionLabel="code"
                optionValue="code"
                [forceSelection]="true"
                [dropdown]="true"
                [showEmptyMessage]="true"
                [minLength]="0"
                name="billing address-level1"
                autocomplete="billing address-level1"
              >
                <ng-template let-item pTemplate="item">
                  <span>{{ item.code }} &mdash; {{ item.name }}</span>
                </ng-template>
              </p-autoComplete>
              <input
                *ngIf="!usesSubdivisionDropdown()"
                pInputText
                id="billing-state"
                type="text"
                formControlName="state"
                name="billing address-level1"
                autocomplete="billing address-level1"
                inputmode="text"
                maxlength="60"
              />
            </span>
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('state')?.touched &&
                paymentForm.get('state')?.hasError('required')
              "
              >State or province is required.</small
            >
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('state')?.touched &&
                paymentForm.get('state')?.hasError('stateCode')
              "
              >Use a 2-letter code for US states or Canadian provinces.</small
            >
            <span class="cdi-form-field cdi-form-row">
              <label for="billing-zip">Zip / Postal Code</label>
              <input
                pInputText
                id="billing-zip"
                type="text"
                formControlName="zipCode"
                name="billing postal-code"
                autocomplete="billing postal-code"
                inputmode="text"
                maxlength="20"
              />
            </span>
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('zipCode')?.touched &&
                paymentForm.get('zipCode')?.hasError('required')
              "
              >Postal code is required.</small
            >
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('zipCode')?.touched &&
                paymentForm.get('zipCode')?.hasError('zipPattern')
              "
              >Enter a valid postal code for the selected country.</small
            >
            <span class="cdi-form-field cdi-form-row">
              <label for="billing-country">Country</label>
              <p-autoComplete
                inputId="billing-country"
                formControlName="country"
                [suggestions]="filteredCountries"
                (completeMethod)="filterCountries($event)"
                (onSelect)="onCountrySelect($event)"
                optionLabel="code"
                optionValue="code"
                [forceSelection]="true"
                [dropdown]="true"
                [showEmptyMessage]="true"
                [minLength]="0"
                name="billing country"
                autocomplete="billing country"
              >
                <ng-template let-item pTemplate="item">
                  <span>{{ item.code }} &mdash; {{ item.name }}</span>
                </ng-template>
              </p-autoComplete>
            </span>
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('country')?.touched &&
                paymentForm.get('country')?.invalid
              "
              >Country is required (2-letter ISO code).</small
            >
            <span class="cdi-form-field cdi-form-row">
              <label for="billing-email">Email</label>
              <input
                pInputText
                id="billing-email"
                type="email"
                formControlName="email"
                name="email"
                autocomplete="email"
                inputmode="email"
                maxlength="120"
              />
            </span>
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('email')?.touched &&
                paymentForm.get('email')?.invalid
              "
              >Enter a valid email address.</small
            >
          </section>
          <section id="cdi-paymentdialog-paymentdetails-section">
            <span><h2>Payment Details</h2></span>
            <span class="cdi-form-field">
              <label>Card Type</label>
              <span class="cdi-card-type-readonly">
                <i [class]="brandIconClass()" aria-hidden="true"></i>
                {{ brandLabel() }} ({{ paymentForm.getRawValue().cardType }})
              </span>
            </span>
            <span class="cdi-form-field">
              <label for="cc-number">Card Number</label>
              <input
                pInputText
                id="cc-number"
                type="tel"
                formControlName="cardNumber"
                name="cc-number"
                autocomplete="cc-number"
                inputmode="numeric"
                maxlength="23"
                (input)="onCardNumberInput()"
              />
            </span>
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('cardNumber')?.touched &&
                paymentForm.get('cardNumber')?.hasError('required')
              "
              >Card number is required.</small
            >
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('cardNumber')?.touched &&
                paymentForm.get('cardNumber')?.hasError('luhn')
              "
              >Card number is not valid.</small
            >
            <span class="cdi-form-field cdi-expiration-row">
              <label for="cc-exp-month">Expiration</label>
              <span class="cdi-expiration-selects">
                <p-select
                  inputId="cc-exp-month"
                  formControlName="expirationMonth"
                  [options]="monthOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Month"
                  [style]="{ minWidth: '100px' }"
                  autocomplete="cc-exp-month"
                ></p-select>
                <p-select
                  inputId="cc-exp-year"
                  formControlName="expirationYear"
                  [options]="yearOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Year"
                  [style]="{ minWidth: '100px' }"
                  autocomplete="cc-exp-year"
                ></p-select>
              </span>
            </span>
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('expirationMonth')?.touched &&
                paymentForm.get('expirationMonth')?.invalid
              "
              >Select month.</small
            >
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('expirationYear')?.touched &&
                paymentForm.get('expirationYear')?.invalid
              "
              >Select year.</small
            >
            <small
              class="cdi-error"
              *ngIf="paymentForm.touched && paymentForm.hasError('expired')"
              >Card is expired.</small
            >
            <span class="cdi-form-field">
              <label for="cc-csc">CVV</label>
              <input
                pInputText
                id="cc-csc"
                type="password"
                formControlName="cvv"
                name="cc-csc"
                autocomplete="cc-csc"
                inputmode="numeric"
                maxlength="4"
              />
            </span>
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('cvv')?.touched &&
                paymentForm.get('cvv')?.hasError('required')
              "
              >Security code is required.</small
            >
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('cvv')?.touched &&
                paymentForm.get('cvv')?.hasError('cvvLength')
              "
              >Enter a valid CVV length for this card.</small
            >
            <span class="cdi-form-field">
              <label for="payment-amount">Payment Amount</label>
              <input
                pInputText
                id="payment-amount"
                type="text"
                name="payment-amount"
                autocomplete="transaction-amount"
                readonly
                tabindex="-1"
                [value]="amountValue | number: '1.2-2'"
              />
            </span>
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('amount')?.touched &&
                paymentForm.get('amount')?.hasError('required')
              "
              >Amount is required.</small
            >
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('amount')?.touched &&
                paymentForm.get('amount')?.hasError('min')
              "
              >Amount must be greater than zero.</small
            >
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('amount')?.touched &&
                paymentForm.get('amount')?.hasError('maxAmount')
              "
              >Amount cannot exceed the order balance.</small
            >
            <span class="cdi-form-field">
              <label for="currency-code">Currency</label>
              <input
                pInputText
                id="currency-code"
                type="text"
                formControlName="currency"
                name="currency"
                autocomplete="transaction-currency"
                inputmode="text"
                maxlength="3"
                readonly
              />
            </span>
            <small
              class="cdi-error"
              *ngIf="
                paymentForm.get('currency')?.touched &&
                paymentForm.get('currency')?.invalid
              "
              >Use a 3-letter ISO currency code.</small
            >
          </section>
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: flex-end;
              gap: 10px;
              padding: 5px;
            "
          >
            <p-button
              id="cdi-btn-cancel-payment-dialog"
              label="Cancel"
              severity="danger"
              type="button"
              (click)="closePaymentDialog()"
            />
            <p-button
              id="cdi-btn-submit-payment-dialog"
              label="Submit"
              severity="success"
              type="submit"
              [disabled]="paymentForm.invalid || submitting"
              [loading]="submitting"
            />
          </div>
        </form>
      </p-dialog>
    </section>
  </section>
</div>
